// import React, { useEffect, useState } from "react";
// // import Logo from "./../../Image/LogoMain.svg";
// import { Container, Row, Col } from "react-bootstrap";
// import axios from "axios";
// import { ApiPaths } from "./../../Config/ApiPath";
// import Loader from "../../Components/Loader/Loader";
// import { Data } from "../../Common/Data";
// import ConnectButton from "../../Components/ConnectButton";
// import { Link, useNavigate } from "react-router-dom";
// import "./LoginRegisterDap.css";
// import { useSelector } from "react-redux";
// import useAxiosHelper from "../../Common/AxiosHelper";
// import Logo from "./../../Images/logo.png";
// import LogoIcon from "./../../Images/logoIcon.png";
// import LogoText from "./../../Images/logoText.png";
// import apiCall from "../../API/API";
// const UserRegister = () => {
//   const [sponsorUsername, setSponsorUsername] = useState("");
//   const [loading, setLoading] = useState(false);
//   const acc = useSelector((state) => state.account.value);
//   const navigate = useNavigate();
//   const { AxiosPost } = useAxiosHelper();

//   const urlParams = new URLSearchParams(window.location.search);
//   const token = urlParams.get("token");
//   const basepath = process.env.REACT_APP_API_URL;
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         if (token && token.length > 10) {
//           const response = await axios.get(`${basepath}/get_profile`, {
//             headers: { Authorization: token },
//           });
//           if (response) {
//             console.log(response);
//             localStorage.setItem("token", token);
//             navigate("/dashboard");
//           }
//         }
//       } catch (err) {
//         console.log(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [token]);

//   useEffect(() => {
//     const after = window.location.search.slice(
//       window.location.search.indexOf("=") + 1
//     );
//     setSponsorUsername(after);
//   }, []);

//   const LoginFunc = async () => {
//     localStorage.clear();
//     if (acc && acc.length > 0) {
//       try {
//         setLoading(true);
//         const body = { username: acc };
//         console.log(body, "..body");
//         const response = await apiCall("POST","/login-with-dap", body);
//         if (response?.status == 200) {
//           console.log("response", response?.user[0]?.uid);
//           localStorage.setItem("userId", response?.user[0]?.uid);
//           localStorage.setItem("token", response?.token);
//           toastSuccess("Login successful!");
//           navigate("/dashboard");
//         } else {
//           toastFailed(response?.data?.message || "Login failed");
//         }
//       } catch (error) {
//         console.error("Error during login:", error);
//         toastFailed(
//           error?.response?.data?.message || "An error occurred during login"
//         );
//       } finally {
//         setLoading(false);
//       }
//     } else {
//       toastFailed("Please connect your wallet");
//     }
//   };

//   const RegisterFunc = async () => {
//     localStorage.clear();
//     const valid = await registerValidation();
//     if (valid) {
//       try {
//         setLoading(true);
//         const body = {
//           sponsorUsername: sponsorUsername,
//           userWalletAddress: acc,
//         };
//         console.log(body, "..body");
//         const response = await AxiosPost(ApiPaths.register, body);
//         if (response?.status == 200) {
//           localStorage.setItem("userId", response?.user?.uid);
//           localStorage.setItem("token", response?.token);
//           // console.log(response?.data?.u_id, "ppppppppppp");
//           toastSuccess("Registration successful!");
//           navigate("/dashboard");
//         } else {
//           toastFailed(response?.data?.error || "Registration failed");
//         }
//       } catch (error) {
//         console.error("Error during registration:", error);
//         toastFailed(
//           error?.response?.data?.error ||
//             "An error occurred during registration"
//         );
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const registerValidation = async () => {
//     if (sponsorUsername.length > 0) {
//       if (acc && acc.length > 0) {
//         return true;
//       } else {
//         toastFailed("Please connect your wallet");
//         return false;
//       }
//     } else {
//       toastFailed("Insert sponsor address");
//       return false;
//     }
//   };

//   return (
//     <>
//       {loading ? <Loader /> : null}
//       <Container id="logincontainer">
//         <div className="loginContainerContent">
//           <Row md="12">
//             <Col>
//               <div className="loginContent">
//                 <div className="loginHeaderContent">
//                   <div className="loginLogo">
//                     <img src={LogoIcon} alt="logo.png" id="logoIcon" />
//                     <img src={LogoText} alt="logo.png" id="logoText" />
//                   </div>
//                   <ConnectButton />
//                 </div>
//                 <div className="loginContent_inner">
//                   <h1 className="heading">Automatic Registration</h1>
//                   <div className="loginInputs">
//                     <div className="loginInput_inner mb-2">
//                       <input
//                         type="text"
//                         placeholder="Sponsor Username"
//                         value={sponsorUsername}
//                         onChange={(e) => setSponsorUsername(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="loginFooter_btn">
//                     <button
//                       className="w-100 mb-2 btn-grad"
//                       onClick={RegisterFunc}
//                       id="registerBtn"
//                     >
//                       Register
//                     </button>
//                     <p className="sign_log">Already have an account?</p>
//                     <Link onClick={LoginFunc} className="btn-grad mt-2">
//                       Automatic Login
//                     </Link>
//                   </div>
//                   <div style={{ textAlign: "center" }}>
//                     <h2 id="trustShlogan">
//                       BUILD ON THE <br />
//                       <span
//                         style={{
//                           color: "var(--textColor)",
//                           fontWeight: "700",
//                           padding: "10px",
//                         }}
//                       >
//                         INTERCHAIN!
//                       </span>
//                     </h2>
//                   </div>
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </div>
//       </Container>
//     </>
//   );
// };

// export default UserRegister;

import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import apiCall from "../../API/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { set } from "lodash";
import { API_BASE_PATH_USER } from "../../API/API";
const UserRegister = () => {
  const [sponsorUsername, setSponsorUsername] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [deposit, setDeposit] = useState("");
  const [withdrawal, setWithdrawal] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");
  const [packageData, setPackageData] = useState([]);
  const [selectPackage, setSelectPackage] = useState();
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [existUsername, setExistUsername] = useState();

  const basepath = API_BASE_PATH_USER;
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log("hellloooooooooo");

    if (!sponsorUsername || !walletAddress) {
      toast.error("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };

      const body = {
        sponsorUsername: sponsorUsername,
        userWalletAddress: walletAddress,
      };
      console.log("body===>", body);
      const response = await axios.post(
        `${basepath}/register-with-dap`,
        body,
        config
      );
      console.log(`${basepath}/register-with-dap`, response.data);
      console.log("response===>", response);
      if (response.data) {
        toast.success(response.data.message);
        setSponsorUsername("");
        setWalletAddress("");
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error.response?.data?.message || "An error occurred");
    }

    setLoading(false);
  };

  var x = 0;

  //   useEffect(() => {
  //     if (x == 0) {
  //       fetchPackage();
  //       x++;
  //     }
  //   }, []);
  //   const fetchPackage = async (e) => {
  //     try {
  //       const { data, error } = await apiCall("GET", "/get_plans?type=binary");
  //       setPackageData(data?.data);
  //       console.log(data.data, "....");
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  const isUserExist = async () => {
    setLoading(true);

    if (!sponsorUsername) {
      setExistUsername(". . .");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: sponsorUsername,
      });
      if (data) {
        setExistUsername(data.name);
      } else if (error) {
        setExistUsername("User not exists");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  useEffect(() => {
    // Clear the timeout when the user is typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to call the API after the user stops typing
    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000) // 500ms debounce delay
    );

    // Cleanup the timeout when the component is unmounted or when typing continues
    return () => clearTimeout(typingTimeout);
  }, [sponsorUsername]);

  return (
    <React.Fragment>
      <Container className="mt-4">
        <Row md="12">
          <Col lg="3"></Col>
          <Col lg="6">
            <section
              id="add-funds-section"
              style={{
                padding: "20px",
                background: "white",
                borderRadius: "5px",
              }}
            >
              <div className="d-flex justify-content-center">
                <h2 className="userRegister">User Register</h2>
              </div>
              <section id="formContent">
                <div className="form">
                  <Row>
                    <Col lg={12} style={{ margin: "auto" }}>
                      <div>
                        <div id="formFields">
                          <div className="mb-3">
                            <div className="d-flex">
                              <label htmlFor="sponsorUsername">
                                Sponsor Username:
                              </label>
                              <label
                                style={{ textAlign: "end" }}
                                htmlFor="sponsorUsername"
                              >
                                {loading && sponsorUsername
                                  ? "Loading..."
                                  : existUsername}
                              </label>
                            </div>
                            <input
                              type="text"
                              id="sponsorUsername"
                              className="form-control"
                              value={sponsorUsername}
                              onChange={(e) =>
                                setSponsorUsername(e.target.value)
                              }
                              placeholder="Enter Sponsor Username"
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="walletAddress">
                              Wallet Address:
                            </label>
                            <input
                              type="text"
                              id="walletAddress"
                              className="form-control"
                              value={walletAddress}
                              onChange={(e) => setWalletAddress(e.target.value)}
                              placeholder="Enter Wallet Address"
                            />
                          </div>
                          <Button
                            type="submit"
                            variant="primary"
                            onClick={handleSubmit}
                            style={{ width: "100%" }}
                          >
                            Register
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </section>
            </section>
          </Col>
        </Row>
        {/* {/* <ToastContainer className="toast-container" /> */}
      </Container>
    </React.Fragment>
  );
};

export default UserRegister;
